import { useModel as _useModel, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, normalizeStyle as _normalizeStyle, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, createBlock as _createBlock, normalizeClass as _normalizeClass, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "text-h6 text-center mb-4"
}
const _hoisted_2 = {
  key: 1,
  class: "text-subtitle-2 text-center mb-4"
}

import { ref, computed, getCurrentInstance } from "vue";
import { DialogAction } from "@/services/dialogAction";
import { useDisplay } from "vuetify";

interface DialogProps {
    /** The title displayed at the top of the dialog */
    title: {
        type: String;
        required: false;
        default: "";
    };
    /** The main text displayed in the dialog */
    text: {
        type: String;
        required: false;
        default: "";
    };
    /** Whether the dialog is persistent (cannot close by clicking outside) */
    persistent: {
        type: Boolean;
        required: false;
        default: true;
    };
    /** The width of the dialog */
    heigth: {
        type: String;
        required: false;
        default: "40vw";
    };
    /** The width of the dialog */
    width: {
        type: String;
        required: false;
        default: "40vw";
    };
    /** The max width of the dialog */
    maxWidth: {
        type: String;
        required: false;
        default: "60vw";
    };
    /** The min width of the dialog */
    minWidth: {
        type: String;
        required: false;
        default: "20vw";
    };
    /** The text displayed on the validation button */
    validText: {
        type: String;
        required: false;
        default: "Valider";
    };
    /** Whether the validation button should be disabled */
    validDisabled: {
        type: Boolean;
        required: false;
        default: false;
    };
    /** Whether the dialog is in a loading state */
    loading: {
        type: Boolean;
        required: false;
        default: false;
    };
    validLoading?: boolean;
    /** Actions available in the dialog */
    actions?: { action: DialogAction };

    prefixDataCy?: string;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'ossConfirm',
  props: /*@__PURE__*/_mergeModels({
    title: {},
    text: {},
    persistent: {},
    heigth: {},
    width: {},
    maxWidth: {},
    minWidth: {},
    validText: {},
    validDisabled: {},
    loading: {},
    validLoading: { type: Boolean },
    actions: {},
    prefixDataCy: {}
  }, {
    "modelValue": { type: Boolean, ...{
    default: false,
    } },
    "modelModifiers": {},
  }),
  emits: /*@__PURE__*/_mergeModels(["valid", "close"], ["update:modelValue"]),
  setup(__props: any, { emit: __emit }) {

const { mobile } = useDisplay();

const props = __props;

const emits = __emit;

const currentInstance = getCurrentInstance();

const $props = computed<Record<string, unknown>>(() => currentInstance?.vnode?.props || {});

const shouldEmitValidation = computed<boolean>(() => !!$props.value.onValid);

const hasFunctionInActions = computed(
    () =>
        !!props.actions?.action?.function &&
        props.actions?.action?.function instanceof Function &&
        props.actions?.action?.display,
);

const hasValidButton = computed(() => shouldEmitValidation.value || hasFunctionInActions.value);

const loading = computed(() => props.loading || localLoading.value);

const dialog = _useModel<boolean>(__props, "modelValue", {
    set: (value) => {
        if (!value) {
            emits("close");
        }
        return value;
    },
    get: (value) => value,
});

const localLoading = ref(false);

const isLoading = computed(() => props.loading || localLoading.value);

const validEvent = async () => {
    localLoading.value = true;
    try {
        emits("valid");
    } catch (error) {
        console.error("Erreur lors de la validation :", error);
    } finally {
        localLoading.value = false;
    }
};

const closeDialog = () => {
    dialog.value = false;
};

// ---- SLOT PARAMS ----

const activatorSlotParams = computed(() => {
    return {
        onClick: () => {
            dialog.value = true;
        },
    };
});

const actionSlotParams = computed(() => {
    return {
        onClick: validEvent,
    };
});

return (_ctx: any,_cache: any) => {
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_btn_primary = _resolveComponent("v-btn-primary")!
  const _component_v_overlay = _resolveComponent("v-overlay")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _renderSlot(_ctx.$slots, "activator", { props: activatorSlotParams.value }),
    _createVNode(_component_v_overlay, {
      modelValue: dialog.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((dialog).value = $event)),
      width: _unref(mobile) ? '100%' : undefined,
      class: _normalizeClass({ 'align-center': !_unref(mobile), 'align-end': _unref(mobile), 'justify-center': true })
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_card, {
          class: "d-flex flex-column align-center justify-center",
          style: _normalizeStyle({
                width: _ctx.width,
                maxWidth: _ctx.maxWidth,
                minWidth: _ctx.minWidth,
                padding: '16px',
            }),
          rounded: "lg"
        }, {
          default: _withCtx(() => [
            (_ctx.title)
              ? (_openBlock(), _createElementBlock("div", _hoisted_1, _toDisplayString(_ctx.title), 1))
              : _createCommentVNode("", true),
            (_ctx.text)
              ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(_ctx.text), 1))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["style"]),
        _renderSlot(_ctx.$slots, "actions", {
          props: actionSlotParams.value,
          class: "mt-2"
        }, () => [
          (hasValidButton.value)
            ? (_openBlock(), _createBlock(_component_v_btn_primary, {
                key: 0,
                block: "",
                size: "x-large",
                onClick: validEvent,
                loading: loading.value || _ctx.validLoading,
                "data-cy": _ctx.prefixDataCy + '_action'
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.validText), 1)
                ]),
                _: 1
              }, 8, ["loading", "data-cy"]))
            : _createCommentVNode("", true)
        ])
      ]),
      _: 3
    }, 8, ["modelValue", "width", "class"])
  ], 64))
}
}

})